<div id="main-container" class="col-md-4 bannerBg">
  <span id="CHCCPac"></span>
</div>

@for (list of lists; track list) {
  <div id="questionLists" class="col-md-10 mt-4">
    <h2>{{ list.title }}</h2>
    <p [innerHTML]="list.text"></p>
    <p>
      {{ list.text2 }}
    </p>
    <p>
      {{ list.text3 }}
    </p>
    <p>
      {{ list.text4 }}
    </p>
  </div>
}
